import React from 'react';
import { AlertDialog, AlertDialogButton } from 'react-onsenui';
import { Result } from 'antd-mobile';
import PropTypes from 'prop-types';
import './BecomingLiveScorerConfirmationModal.css';

const BecomingLiveScorerConfirmationModal = props => (
    <AlertDialog isOpen={props.show} onCancel={props.done}>
        <div className="alert-dialog-title ls_bravo_title">
            <Result
                style={{backgroundColor: 'transparent'}} 
                img={<img src={require('../../images/bravo.png')} style={{width: '90px', height: 'auto'}} alt='' />} 
                title={<h6 style={{marginBottom: 0, color: '#004586', fontWeight: '700', fontFamily: 'fff-equipe'}}>Bravo !</h6>} 
            />
        </div>
        <div className="alert-dialog-content" style={{fontSize: '14px', textAlign: 'center', marginTop: 0, color: '#004586', fontFamily: 'fff-equipe'}}>
            Tu fais partie des Live Scorer pour ce match. Tu pourras démarrer ton live 1h avant le début du match.
        </div>
        <div className="alert-dialog-footer">
            <AlertDialogButton onClick={props.done}>
                <span style={{fontWeight: '700', textAlign: 'center', color: '#004586', fontFamily: 'fff-equipe'}}>J'ai compris</span>
            </AlertDialogButton>
            <AlertDialogButton onClick={props.cancel}>
                <span style={{fontWeight: '700', textAlign: 'center', color: '#004586', fontFamily: 'fff-equipe'}}>ANNULER</span>
            </AlertDialogButton>
        </div>
    </AlertDialog>
);

BecomingLiveScorerConfirmationModal.propTypes = {
    done: PropTypes.func.isRequired,
    cancel: PropTypes.func.isRequired,
    show: PropTypes.bool.isRequired
}

export default BecomingLiveScorerConfirmationModal;